export default "__VITE_ASSET__DrrpUTDX__"